'use client';

import Link from 'next/link';

type Props = {
  children: React.ReactNode;
  closeLink?: string;
  closeFunction?: () => void;
  title?: string;
};

export default function Modal({ children, closeLink, title, closeFunction }: Props) {
  return (
    <div className="fixed inset-0 z-30 flex h-full w-full items-center justify-center overflow-y-auto bg-gray-600 bg-opacity-50">
      <div className="relative h-full w-full rounded-md border bg-white shadow-lg lg:h-auto lg:w-3/4 lg:p-8">
        <div className="h-full text-center">
          {title && <h3 className="text-2xl font-bold text-gray-900">{title}</h3>}
          <div className="mt-2 h-full px-2 py-3 lg:px-7">{children}</div>
          <div className="absolute right-[10px] top-0 mt-4  lg:flex">
            {closeLink && 
            <Link
              href={closeLink}
              onClick={closeFunction}
              className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-zinc-200 text-black"
            >
              <span className="">X</span>
            </Link>}
            {!closeLink && closeFunction && (
              <button
                onClick={closeFunction}
                className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-zinc-200  bg-white text-black"
              >
              <span className="">X</span>
            </button>)}
          </div>
        </div>
      </div>
    </div>
  );
}
